export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            var commentaryToolbar = $('.toolbar.toolbar--commentary');

            if (commentaryToolbar.length > 0) {
                var toolbarOffset = commentaryToolbar.offset();
                var toolbarTop = toolbarOffset.top;

                $(window).scroll(function () {
                    var scrollTop = $(document).scrollTop();

                    if (scrollTop >= toolbarTop) {
                        $('header').addClass('header--has-toolbar');
                        $(commentaryToolbar).addClass('toolbar--sticky');
                    } else {
                        $('header').removeClass('header--has-toolbar');
                        $(commentaryToolbar).removeClass('toolbar--sticky');
                    }
                });
            }
        });
    };

    return _instance;

})(jQuery)